import { render, staticRenderFns } from "./EntradaCompraFormComponent.vue?vue&type=template&id=730b5433&"
import script from "./EntradaCompraFormComponent.vue?vue&type=script&lang=js&"
export * from "./EntradaCompraFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports